import React, { useState, useEffect } from 'react';
import {useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { isEmpty } from 'lodash';

import { usePagination } from '../../../hooks';
import { getAllNewsFeed, popup } from '../../../utils';
import { CUSTOMER_NEWS_FEED_COLUMNS, QUERY_KEYS } from '../../../constants';
import { AdminPageHeader } from '../../Admin';
import EmptyImage from '../../../assets/img/icons/empty-img-doc.svg';
import { Table } from '../../shared';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const AllNewsFeedCustomer = () => {
    const accountId = useSelector((state) => state.accountArray.selectedAccount);
    const selectedAccountName = useSelector((state) => state.accountArray.selectedAccountName);
    const [search, setSearch] = useState(null);
    const [response, setResponse] = useState({ data: [], count: 0 });
    const pagination = usePagination(response.data.length, response.count);
    
    const [debounceSearch] = useDebouncedValue(search, 500);
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [
            QUERY_KEYS.NEWS_FEED,
            accountId,
            debounceSearch,
            pagination.offset,
            pagination.limit,
        ],
        queryFn: async () =>
            await getAllNewsFeed({
                account_id: accountId,
                search: debounceSearch,
                limit: pagination.limit,
                offset: pagination.offset,
            }),
        select: (data) => ({ data: data.data, count: data.count }),
        placeholderData: { data: [], count: 0 },
        enabled: !!accountId,
    });

    useEffect(() => {
        if (data.data && isFetched) {
            setResponse({ data: data.data, count: data.count });
        }
    }, [data, isFetched]);

    if (isError) popup('error', error.message);

    return (
        <>
            <AdminPageHeader
                heading={'All News Feed'}
                backbutton
                showSearchBar={true}
                searchBarPlaceholder={'Search feed'}
                setSearch={setSearch}
                count={pagination.dataCount}
            />
            <div className='ssc-newsfeed-box'>
                <div className='p-3 name-box-set d-flex align-items-center justify-content-start'>
                    <div>
                        <h6 className='name m-0'>{selectedAccountName}</h6>
                    </div>
                </div>
            </div>
            {!isEmpty(response?.data) ? (
                <div className='mt-3'>
                    <Table
                        columns={CUSTOMER_NEWS_FEED_COLUMNS}
                        data={response?.data}
                        pagination={pagination}
                        pageName={'Feeds'}
                        stickyColumns={['News Feed']}
                        tableStyle={{
                            height: 'calc(100vh - 400px)',
                            overflow: 'auto',
                        }}
                        isLoading={isFetching}
                    />
                </div>
            ) : (
                <div className='d-flex flex-column w-100 h-75 justify-content-center align-items-center gap-3'>
                    <img src={EmptyImage} alt='img' width={176} height={138} />
                    <p>There are no news feed for this client</p>
                </div>
            )}
        </>
    );
};
